/**
 * Common envelope fields shared by all cursor-paginated API responses.
 * Extend this interface and add an `items` field with the resource-specific type.
 */
export interface PageMeta {
  items_number: number
  // Count of items in this response.

  limit: number
  // Page size requested.

  next_cursor: number | null
  // Cursor for the following page; null when no further pages exist.

  has_next_page: boolean
  // Whether another page exists after this one.

  order: string
  // Sort order key returned by the API.
}

/**
 * Builds the query-param object for a cursor-paginated GET request.
 * Pass `next_cursor` from a previous response as `cursor` to advance to the next page.
 *
 * @example
 * http.get('/payments', { params: cursorParams(paymentsPageLimit, cursor) })
 */
export function cursorParams(limit: number, cursor?: number): { limit: number; cursor?: number } {
  return cursor !== undefined && cursor !== null ? { limit, cursor } : { limit }
}
